import { EvaluationActionDropdown } from './EvaluationAction';
import { MassActionDropdown } from './MassAction';

export const Dropdown = {
  MassAction: MassActionDropdown,
  EvaluationAction: EvaluationActionDropdown,
};
